<template>
  <div class="v-table-td-subject">
    <DropdownCustom ref="dpcRef"
                    class="v-table-td-subject-dpc"
                    equalWidth
                    v-if="editing"
                    :toggleIcon="false"
                    trigger="manual">
    <textarea
        ref="textareaRef"
        placeholder="请输入科目名称/科目编码/科目名称拼音首字母快速搜索"
        v-model="subjectVal"
        @input="onSubjectValChange"
        @blur="canEditing&&endEdit()"
        @keydown.tab.prevent="onEnter"
        @keydown.enter.prevent="onEnter"
        @keydown.left="moveTab(-1)"
        @keydown.right="moveTab(1)"
        @keydown.up="moveSelect(-1)"
        @keydown.down="moveSelect(1)"
        class="v-table-td-subject-edit"
    ></textarea>
      <template #content>
        <div ref="subjectListRef" class="v-table-td-subject-list" @mouseenter="canEditing=false" @mouseleave="onMouseleave">
          <div class="type-tabs" ref="tabsRef">
            <div :class="subjectType==='全部'?'selected':''" @click="subjectType='全部'">全部</div>
            <div v-for="type in store.state.subjectType" @click="subjectType=type" :class="subjectType===type?'selected':''">{{ type }}</div>
          </div>
          <div class="v-table-td-subject-list-content">
            <ul ref="subjectUlRef">
              <li :class="{'subject-selected':filterVal===s.code}" @click="selectSubject" :data-code="s.code"
                  :data-id="s.id" v-for="s in subjectListFilter" :key="s.code">{{ s.code }} {{ s.fullName }}
              </li>
            </ul>
          </div>
          <div @click="newSubject" class="text-hover text-center py-4px">
            <i class="fa fa-plus-circle"></i> 添加科目
          </div>
        </div>
      </template>
    </DropdownCustom>
    <div v-else class="p-8px h-full v-table-td-subject-text" @click="doEdit">
      <template v-if="subjectObj">
        {{ subjectObj.code }} {{ subjectObj.fullName }}
        <template v-if="auxiliary">
          <span v-for="ax in auxiliary">{{ ax.code }}-{{ ax.name }}</span>
        </template>
        <div class="addon" @click.stop="void(0)" v-if="hasAuxiliary">
          <Tooltip content="辅助项">
            <i @click="setAuxiliary" class="fa  fa-vcard text-hover"></i>
          </Tooltip>
        </div>
      </template>
    </div>
    <div v-if="detail.subjectBalance && !subjectObj.unit" class="v-table-td-subject-balance" :class="detail.subjectBalance<0?'red-color':''">
      余额：{{ numFormat(detail.subjectBalance) }}
    </div>
    <div v-if="detail.subjectBalance && subjectObj.unit" class="v-table-td-subject-balance" :class="detail.subjectBalance<0?'red-color':''">
      余额：{{ numFormat(detail.subjectBalance) }} 均价：{{ detail.subjectBalancePrice }}
    </div>
    <div @click.stop="void(0)" v-if="subjectObj && (subjectObj.unit || hasCurrency)" class="v-table-td-subject-unit-currency">
      <div v-if="subjectObj.unit" class="text-hover">
        <DropdownCustom :toggleIcon="false" ref="unitDp">
          数量：{{ detail.num || 0 }} {{ subjectObj.unit }}，单价：{{ detail.price || 0 }}
          <template #content>
            <div class="h-input-group">
              <span class="h-input-addon">数量：</span>
              <NumberInput autofocus @change="numChange" v-model.number="detail.num" placeholder="请输入数量"/>
              <span class="h-input-addon">{{ subjectObj.unit }}</span>
            </div>
            <div class="h-input-group mt-5px">
              <span class="h-input-addon">单价：</span>
              <NumberInput @change="numChange" v-model.number="detail.price" placeholder="请输入单价"/>
            </div>
          </template>
        </DropdownCustom>
      </div>
      <div class="mt-5px text-hover" v-if="hasCurrency && currency">
        <DropdownCustom :toggleIcon="false" ref="currencyDp">
          币别：{{currency.code}} ，汇率：{{detail.exchangeRate}}，原币:{{detail.amountFor || 0}}
          <template #content>
            <div class="h-input-group">
              <span class="h-input-addon">汇率：</span>
              <NumberInput autofocus @change="currencyAmtChanges" v-model.number="detail.exchangeRate" placeholder="请输入汇率"/>
            </div>
            <div class="h-input-group mt-5px">
              <span class="h-input-addon">原币：</span>
              <NumberInput autofocus @change="currencyAmtChange" v-model.number="detail.amountFor" placeholder="请输入原币"/>
            </div>
          </template>
        </DropdownCustom>

      </div>
    </div>
  </div>
</template>
<script setup>

import {computed, getCurrentInstance, h, nextTick, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {getVTable} from "@components/VoucherTable/VtUtil";
import {scrollIntoView} from "heyui.ext";
import VTableAuxiliary from "@components/VoucherTable/VTableAuxiliary.vue";
import {layer} from "@layui/layer-vue";
import SubjectForm from "@/views/setting/subject/SubjectForm.vue";
import setting from "@api/setting";
import {add, divide, multiply, pick, round, subtract} from "xe-utils";

const props = defineProps(['subject', 'rowIndex', 'subjectList', 'subjectMap', 'auxiliary', 'detail','rowOperate','voucherDate']);
const store = useStore();

const dpcRef = ref(null)
const textareaRef = ref(null)
const tabsRef = ref(null)
const subjectUlRef = ref(null)

const editing = ref(false)
const canEditing = ref(true)
const subjectVal = ref("")
const filterVal = ref(null)
const unitDp = ref(null)
const currencyDp = ref(null)
const subjectType = ref("全部")
const subjectObj = ref(null)
const subjectBalance = ref(null)
const currency = ref(null)

const emits = defineEmits(['update',"childNewSubject", 'updateParentData']);

const subjectOriginalBalance = ref(null)

let VTable = null;

//调整两个watch监听器的顺序，解决编辑凭证时，subjectObj监听不全，导致只能获得前5行凭证的余额信息
watch(subjectObj, (subject) => {
	subject && loadSubjectBalance(subject.id);
  loadCurrency(subject);
})

watch(() => props.subject, (val) => {
	subjectObj.value = val;
	if (val) {
		subjectVal.value = val.code + " " + val.fullName;
	} else {
		subjectVal.value = "";
	}
}, {immediate: true})



watch(() => [props.detail.debitAmount, props.detail.creditAmount], (amount) => {
	if (props.detail.subject) {
		let orgVal = 0;
		switch (props.detail.subject.balanceDirection) {
			case '借':
				//原始值
        //subjectOriginalBalance.value原始余额
				orgVal = subjectOriginalBalance.value + props.detail.originalCreditAmount - props.detail.originalDebitAmount;
				subjectBalance.value = round(subtract(add(orgVal, amount[0] || 0), amount[1] || 0), 2);
				props.detail.subjectBalance = round(subtract(add(orgVal, amount[0] || 0), amount[1] || 0), 2);
				break;
			case '贷':
				orgVal = subjectOriginalBalance.value - props.detail.originalCreditAmount + props.detail.originalDebitAmount;
				subjectBalance.value = round(subtract(add(orgVal, amount[1] || 0), amount[0] || 0), 2);
        props.detail.subjectBalance = round(subtract(add(orgVal, amount[1] || 0), amount[0] || 0), 2);
				break;
		}
	}
})

/**
 * 是否带辅助
 * @type {ComputedRef<boolean>}
 */
const hasAuxiliary = computed(() => {
	return subjectObj && subjectObj.value && subjectObj.value.auxiliaryAccounting && subjectObj.value.auxiliaryAccounting.length;
})
/**
 * 是否带外币
 * @type {ComputedRef<boolean>}
 */
const hasCurrency = computed(() => {
  // console.log("科目",subjectObj.value);
	return subjectObj && subjectObj.value && subjectObj.value.currencyAccounting && subjectObj.value.currencyAccounting.length>0;
})

function filter(val) {
	if (filterVal.value) {
		return (val.code.indexOf(filterVal.value) !== -1 ||
				val.fullName.indexOf(filterVal.value) !== -1 ||
				val.mnemonicCode.indexOf(filterVal.value) !== -1);
	}
	return true;
}

/**
 * 科目过滤
 * @type {ComputedRef<unknown>}
 */
const subjectListFilter = computed(() => {
	if (subjectType.value === '全部') {
		if (filterVal.value) {
			return props.subjectList.filter(val => filter(val));
		}
		return props.subjectList;
	}
	return props.subjectList.filter(val => val.type === subjectType.value && filter(val));
})

/**
 * 开启科目编辑
 */
const doEdit = () => {
	editing.value = true;

	nextTick(() => {
		setTimeout(() => {
			dpcRef.value.show();
			nextTick(() => {
				textareaRef.value.focus();
				textareaRef.value.select();
			})
		}, 100);
	})
}

/**
 * 科目输入过滤值
 * @param e
 */
const onSubjectValChange = (e) => {
	filterVal.value = e.target.value;
}

/**
 * 结束编辑
 * @returns {boolean}
 */
const endEdit = () => {
	editing.value = false;
	subjectType.value = '全部'
	filterVal.value = null
	dpcRef.value.hide();
	if (hasAuxiliary.value && (!props.auxiliary || !props.auxiliary.length)) {
		setAuxiliary();
		return false;
	}
	if (subjectObj.value && subjectObj.value.unit) {
		setTimeout(() => {
			unitDp.value.show();
		}, 300)
		return false;
	}
	return true;
}

/**
 * 回车和Tab键操作
 */
const onEnter = () => {
	let selector = subjectUlRef.value.querySelector('.subject-selected');
	setValueAndGoNext(selector)
}

/**
 * 鼠标选择科目
 * @param e
 */
const selectSubject = (e) => {
	setValueAndGoNext(e.target)
}

/**
 * 赋值选择科目
 * @param selector
 */
const setValueAndGoNext = (selector) => {
	let next = 'debitAmount';
	if (selector) {
		let newSubject = props.subjectMap[selector.dataset.id];
    console.log(newSubject,"新选择的科目")
    console.log(props.detail,"这行信息")
    if(newSubject.unit == ""){
      //jxd新选择的科目没有数量
      // props.detail.num = 0;
      // props.detail.price = 0;
      // props.detail.debitNum = 0;
      // props.detail.creditNum = 0;
      VTable.exposed.updateFiled(props.rowIndex, 'num', "");
      VTable.exposed.updateFiled(props.rowIndex, 'price', "");
      VTable.exposed.updateFiled(props.rowIndex, 'debitNum', "");
      VTable.exposed.updateFiled(props.rowIndex, 'creditNum', "");
    }

    if(!newSubject.enableAuxiliary){
      console.log("选择的不是辅助核算")
      VTable.exposed.updateFiled(props.rowIndex, 'auxiliary', []);
      VTable.exposed.updateFiled(props.rowIndex, 'auxiliaryDetailId', "");
      console.log("再次打印这行信息",props.detail)
    }

    if(!newSubject.enableForCurrency){
      //jxd新选择的科目没有外币
      // props.detail.currencyId = store.getters.localCurrency.id;
      // props.detail.creditAmountFor = 0;
      // props.detail.debitAmountFor = 0;
      // props.detail.exchangeRate = 0;
      // props.detail.amountFor = 0;
      // console.log(props.detail)
      VTable.exposed.updateFiled(props.rowIndex, 'currencyId', store.getters.localCurrency.id);
      VTable.exposed.updateFiled(props.rowIndex, 'creditAmountFor', "");
      VTable.exposed.updateFiled(props.rowIndex, 'debitAmountFor', "");
      VTable.exposed.updateFiled(props.rowIndex, 'exchangeRate', "");
      VTable.exposed.updateFiled(props.rowIndex, 'amountFor', "");
    }else{
      // console.log(props.detail)
      loadCurrency(newSubject)
    }

		if (subjectObj.value && newSubject.id !== subjectObj.value.id) {
			//修改了科目清除已选择的辅助项目
			VTable.exposed.updateFiled(props.rowIndex, 'auxiliary', []);
		}

		subjectObj.value = newSubject;
		VTable.exposed.updateFiled(props.rowIndex, 'subject', subjectObj.value);

		subjectVal.value = subjectObj.value.code + " " + subjectObj.value.fullName;
		if (subjectObj.value.balanceDirection === '贷') {
			next = 'creditAmount';
		}
	}
	if (endEdit()) {
		VTable.exposed.next(props.rowIndex, next);
	}
}

/**
 * 鼠标移出科目选择区域
 */
const onMouseleave = () => {
	canEditing.value = true;
	textareaRef.value.focus();
}

/**
 * 切换科目分类过滤
 * @param step
 */
const moveTab = (step) => {
	let selector = tabsRef.value.querySelector('.selected');
	let sibling;
	if (step > 0) {
		sibling = selector.nextElementSibling
	} else {
		sibling = selector.previousElementSibling
	}

	if (sibling) {
		subjectType.value = sibling.innerText.trim();
		sibling.classList.add('selected')
		selector.classList.remove('selected')
	}
}

/**
 * 科目选择键盘方向键控制
 * @param step
 */
const moveSelect = (step) => {
	let selector = subjectUlRef.value.querySelector('.subject-selected');
	let sibling;

	if (selector) {
		if (step > 0) {
			sibling = selector.nextElementSibling
		} else {
			sibling = selector.previousElementSibling
		}
		if (sibling) {
			sibling.classList.add('subject-selected')
			selector.classList.remove('subject-selected')
			scrollIntoView(sibling, {
				time: 500, // 动画时间
			})
		}
	} else {
		sibling = subjectUlRef.value.children[0];
		sibling && sibling.classList.add('subject-selected');
	}
}

/**
 * 设置科目辅助项目
 */
const setAuxiliary = () => {
	let layerId = layer.open({
		title: subjectObj.value.code + " " + subjectObj.value.fullName,
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['500px', 'auto'],
		content: h(VTableAuxiliary, {
			subject: subjectObj.value,
			auxiliary: props.auxiliary,
			onClose: () => {
				layer.close(layerId);
			},
			onSuccess: (auxiliary) => {
				VTable.exposed.updateFiled(props.rowIndex, 'auxiliary', auxiliary || []);
				layer.close(layerId);
				VTable.exposed.next(props.rowIndex, subjectObj.value.balanceDirection === '贷' ? 'creditAmount' : 'debitAmount');
				loadSubjectBalance(subjectObj.value.id,auxiliary)//jxd把设置的辅助项直接传给查询余额，解决辅助项滞后问题
			}
		})
	});
}

const newSubject = () => {
	let layerId = layer.drawer({
		title: "科目信息",
		shadeClose: false,
		closeBtn: false,
		area: ['600px', '100vh'],
		zIndex: 1000,
		content: h(SubjectForm, {
			faster: true,
			onClose: () => {
				layer.close(layerId);
       emits('childNewSubject', "success");//向父组件VTableTr发送添加科目成功事件
				doEdit();
			},
			onSuccess: (code) => {
				layer.close(layerId);
				filterVal.value = code;
				VTable.exposed.loadSubject();
        emits('childNewSubject', "success");//向父组件VTableTr发送添加科目成功事件
				doEdit();
			}
		})
	});
}

const loadSubjectBalance = (subjectId,auxiliary) => {
  if(!props.voucherDate){
    return;
  }
	setting.subject.balanceAndQuantity({
    voucherDate:props.voucherDate,
		currencyId: props.detail.currencyId,
		subjectId: subjectId,
    //auxiliary  jxd,解决页面选择辅助项后，这里传递的props.auxiliary还是上次的，滞后信息
		acDetails: (auxiliary || props.auxiliary || []).map(val => pick(val, ['id', 'categoryType', 'categoryId']))
	}).then(({data}) => {
    // console.log(props.detail)
    // console.log(data)
		subjectBalance.value = data.balance;
    props.detail.subjectBalance = data.balance;
    props.detail.subjectBalancePrice = data.averagePrice;
		subjectOriginalBalance.value = data.balance;
    //如果是结转行的则需要计算结转后的余额jxd，或模版生成的行，因为这些余额都是不包含右侧借贷金额的
    if(props.detail.isCarry){
      switch (props.detail.subject.balanceDirection) {
        case '借':
          // console.log(data , props.detail.debitAmount , props.detail.creditAmount)
          subjectBalance.value= data.balance + props.detail.debitAmount - props.detail.creditAmount;
          props.detail.subjectBalance = data.balance + props.detail.debitAmount - props.detail.creditAmount;
          subjectOriginalBalance.value = data.balance + props.detail.debitAmount - props.detail.creditAmount;
          break;
        case '贷':
          subjectBalance.value= data.balance - props.detail.debitAmount + props.detail.creditAmount;
          props.detail.subjectBalance = data.balance - props.detail.debitAmount + props.detail.creditAmount;
          subjectOriginalBalance.value = data.balance - props.detail.debitAmount + props.detail.creditAmount;
          break;
		  }
    }
	})
}
//查询汇率
const loadCurrency = (subject) => {
  // console.log("嗯？",subject)
  if (!hasCurrency) return;
  // if (props.detail.id) {
  //   //编辑不需要查询外币汇率
  //   return;
  // }
  // console.log("嗯？",subjectObj.value.currencyAccounting)
  if (subjectObj.value && subjectObj.value.currencyAccounting && subjectObj.value.currencyAccounting.length>0) {
    setting.currency.load(subjectObj.value.currencyAccounting[0]).then(res=>{
      currency.value = res.data;
      //jxd编辑，结转损益年结转这种不需要再设置汇率
      if(props.detail.incOrcash !== true){//不是资金或者发票过来的incOrcash做判断的
        if (!props.detail.id && !props.detail.isProfitCheck) {
          console.log(props.rowOperate,"数据")
          if(!props.rowOperate){
            props.detail.exchangeRate = res.data.exchangeRate;
            currencyAmtChanges(currency.value.exchangeRate)//切换科目重算本币
          }
          emits('updateParentData', "false");//向父组件VTableTr发送数据
        }
      }  
      props.detail.currencyId = res.data.id;
    });
  }
  // this.currency = {};
}


const numChange = () => {
	let d = props.detail;
	let field = 'debitAmount';
	let fieldFor = 'debitAmountFor';
	let numField = 'debitNum';

	if (d.creditAmount || (!d.creditAmount && d.subject.balanceDirection === '贷')) {
		field = 'creditAmount';
		fieldFor = 'creditAmountFor';
    numField = 'creditNum';
	}

  if(field == 'debitAmount'){
    props.detail.creditAmount = "";
    props.detail.creditAmountFor = "";
    props.detail.creditNum = "";
  }else{
    props.detail.debitAmount = "";
    props.detail.debitAmountFor = "";
    props.detail.debitNum = "";
  }
 
  if (d.num) {
    d.num = round(d.num,4)
  }
  if (d.price) {
    d.price = round(d.price,4)
  }
  let amount = round(multiply(d.num, d.price), 2);
	props.detail[field] = amount;
	props.detail[numField] = props.detail.num;
  if (currency && currency.value && currency.value.exchangeRate) {
    //开启汇率计算原币金额
    let amountFor = round(divide(amount, currency.value.exchangeRate), 2);
    props.detail.amountFor = amountFor;
    props.detail[fieldFor] = amountFor;
  }

}

const currencyAmtChange = (amtFor) =>{
  /*
    因为之前汇率和原币用一个方法，没法区分输入的是那个
    故改成两个方法，这个是操作的原币
  */
  let d = props.detail;
  let field = 'debitAmount';
  let fieldFor = 'debitAmountFor';
  if (d.creditAmount || (!d.creditAmount && d.subject.balanceDirection === '贷')) {
    field = 'creditAmount';
    fieldFor = 'creditAmountFor';
  }
  if(field == 'debitAmount'){
    props.detail.creditAmount = "";
    props.detail.creditAmountFor = "";
  }else{
    props.detail.debitAmount = "";
    props.detail.debitAmountFor = "";
  }
  if (d.exchangeRate) {
    d.exchangeRate = round(d.exchangeRate,4)
  }
  let rate = d.exchangeRate;
  let amount = round(multiply(amtFor, rate), 2);

  props.detail[field] = amount;
  props.detail[fieldFor] = round(amtFor, 2)

  if (subjectObj && subjectObj.value && subjectObj.value.unit) {
    //开启数量
    if (d.num && d.price) {
      props.detail.price = round(divide(amount, d.num), 2);
    }else if (d.num && !d.price) {
      props.detail.price = round(divide(amount, d.num), 2);
    }else if (!d.num && d.price) {
      props.detail.num = round(divide(amount, d.price), 2);
    }
  }
}

const currencyAmtChanges = (amtFor) =>{
  console.log("我",amtFor)
  /*
    因为之前汇率和原币用一个方法，没法区分输入的是那个
    故改成两个方法，这个是操作的汇率
  */
  let d = props.detail;
  let field = 'debitAmount';
  let fieldFor = 'debitAmountFor';
  if (d.creditAmount || (!d.creditAmount && d.subject.balanceDirection === '贷')) {
    field = 'creditAmount';
    fieldFor = 'creditAmountFor';
  }

  if(field == 'debitAmount'){
    props.detail.creditAmount = "";
    props.detail.creditAmountFor = "";
  }else{
    props.detail.debitAmount = "";
    props.detail.debitAmountFor = "";
  }
  //金额= 汇率 * 原币
  let amount = round(multiply(amtFor, d.amountFor), 2);
  props.detail[field] = amount;
  // props.detail[fieldFor] = round(amtFor, 2)
  console.log(props.detail)
  if (subjectObj && subjectObj.value && subjectObj.value.unit) {
    //开启数量
    if (d.num && d.price) {
      props.detail.price = round(divide(amount, d.num), 2);
    }else if (d.num && !d.price) {
      props.detail.price = round(divide(amount, d.num), 2);
    }else if (!d.num && d.price) {
      props.detail.num = round(divide(amount, d.price), 2);
    }
  }
}


onMounted(() => {
	VTable = getVTable(getCurrentInstance())
})

defineExpose({
	doEdit,
	endEdit
})
</script>
<style scoped lang="less">
.v-table {

  &-td {
    &-subject {
      flex: 1;
      border-right: @border;
      font-weight: bold;
      position: relative;

      &-balance {
        position: absolute;
        bottom: 0;
        left: 8px;
        font-size: 12px;
      }

      &-unit-currency {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 5px 5px 0;
        font-weight: normal;
        z-index: 1;
        text-align: right;
      }

      &-dpc {
        display: block;
        height: 100%;

        :deep(.h-dropdowncustom-show) {
          height: 100%;
        }

        :deep(.h-dropdowncustom-show-content) {
          height: 100%;
          display: block;
        }
      }

      &-edit {
        resize: none;
        outline: none;
        height: 100%;
        width: 100%;
        overflow: hidden;
        font-size: 12px;
        padding: 8px;
        border: 1px solid @green-color;
      }

      &-list {
        font-size: 13px;

        &-content {
          height: 200px;
          overflow-y: auto;
          border-bottom: @border;

          li {
            padding: 4px 8px;
            cursor: pointer;

            &:hover {
              background-color: @gray3-color;
            }
          }
        }
      }

      &-text {
        position: relative;

        .addon {
          position: absolute;
          right: 0;
          top: 0;

          i {
            margin: 5px;
            font-size: 14px;
          }

          .fa-vcard {
            color: #ff6600;
          }

          .fa-money {
            color: @primary-color;
          }
        }
      }
    }
  }
}

.type-tabs {
  display: flex;
  border-bottom: @border;

  div {
    flex: 1;
    text-align: center;
    padding: 5px 0;

    &:hover {
      cursor: pointer;
      background-color: @primary-color;
      color: @white-color;
    }
  }

  .selected {
    background-color: @primary-color;
    color: @white-color;
  }
}

.subject-selected {
  background-color: @primary2-color;
}
</style>
